import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EditPoi from '../../Monitor/POI/EditPOI';
import ListPoi from '../../Monitor/POI/ListPOI';
import ModalConfirmEditPoi from '../../../Modals/ModalConfirmUserInformation';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import AlertBar from '../../../Modals/AlertBar';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import NearTrackingList from './NearTrackingList';
import { checkStatus } from '../../../../util/util';

class POIconfig extends Component {

    constructor() {
        super();

        this.state = {
            editPoiObj: {},
            isEditPoi: false,
            showModalConfirmEditPoi: false,
            poiObj: {},
            notification: false,
            isUpdate: false,
            showModalConfirmDeletePoi: false,
            openList : true,
            openAdd : false,
            openEdit: false,
            onOpenNear:false,
            poiId:'',
            dataPOI:{},
            deviceInfo:{},
        };

    }

    onClickRowListTable = (poiObj) => {
        this.setState({ isEditPoi: true, editPoiObj: poiObj,openList:false,openEdit:true });
    }

    onClickCancelEditPoi = () => {
        this.setState({ isEditPoi: false, showModalConfirmEditPoi: false });
    }

    onClickConfirmAddPoi = (poiObj) => {

        console.log('poiObj',poiObj)
        this.setState({ showModalConfirmEditPoi: false, poiObj });
        AlertConfirm("เพิ่ม POI","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { poiObj, editPoiObj } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
                window.scrollTo(0, 0);
                    fetch(`http://203.150.199.244/api/admin/newPOI`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        
                        "token": token
                    },
                    body: JSON.stringify({
                        "name" : poiObj.name ,
                        "group" : poiObj.group,
                        "radius" : Number(poiObj.radius),
                        "location" : {
                            "latitude" : Number(poiObj.latitude),
                            "longitude" : Number(poiObj.longitude)
                        },
                        "icon" : {
                            "name" : poiObj.icon_name,
                            "color" : poiObj.icon_color,
                            "is_small" : false
                        },
                        "isVisible":true,
                        "is_visible":true,
                             
                    })
                })
                    .then(response => response.json())
                    .then((data) => {

                        console.log(data)
                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                    })

                    .then(() => {
                        this.setState({
                            isUpdate: true,
                            openList:true,
                            openEdit:false,
                            openAdd:false,
                        });
                        if(this.props.onRefreshPOI && this.props.onRefreshPOI!=null)
                            this.props.onRefreshPOI();
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    onClickConfirmUserInformation = (poiObj) => {

        console.log('poiObj',poiObj)
        this.setState({ showModalConfirmEditPoi: false, poiObj });
        AlertConfirm("แก้ไข POI","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const { poiObj, editPoiObj } = this.state;
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
                window.scrollTo(0, 0);
                    fetch(`http://203.150.199.244/api/admin/updatePOI/${poiObj.poi_id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                       
                        "token": token
                    },
                    body: JSON.stringify({
                        "name" : poiObj.name ,
                        "group" : poiObj.group,
                        "radius" : Number(poiObj.radius),
                        "location" : {
                            "latitude" : Number(poiObj.latitude),
                            "longitude" : Number(poiObj.longitude)
                        },
                        "icon" : {
                            "name" : poiObj.icon_name,
                            "color" : poiObj.icon_color,
                            "is_small" : false
                        },
                             
                    })
                })
                    .then(response => response.json())
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                    })

                    .then(() => {
                        this.setState({
                            isUpdate: true,
                            openList:true,
                            openEdit:false,
                            openAdd:false,
                        });
                        // this.onClickBack(poiObj.poi_id);
                        if(this.props.onRefreshPOI && this.props.onRefreshPOI!=null)
                            this.props.onRefreshPOI();
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
    }

    onClickDeletePoi = (delPoiObj) => {
        this.setState({ showModalConfirmDeletePoi: false, poiObj: delPoiObj });
        console.log('delPoiObj',delPoiObj)
        AlertConfirm("ลบ POI","คุณต้องการลบ POI หรือไม่").then(isOk=>{
            if(isOk){
                
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;
        
                const { poiObj } = this.state;
                fetch(`http://203.150.199.244/api/admin/deletePOI/${delPoiObj}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        
                        "token": token
                    },
                    body: JSON.stringify({})
                })
                    .then(response => response.json())
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }
                    })
                    .then(() => {
                       
                        this.setState({
                            isUpdate: true,
                            openList:true,
                            openEdit:false,
                            openAdd:false,
                        });
                        if(this.props.onRefreshPOI && this.props.onRefreshPOI!=null)
                            this.props.onRefreshPOI();
                    
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
            
        });
    }

    onClickCancelDelete = () => {
        this.setState({ showModalConfirmDeletePoi: false })
    }

    onClickConfirmDelete = () => {
        const {
            user_name,
            user_id,
            token
        } = this.props;

        const { poiObj } = this.state;
        fetch(`http://203.150.199.244/api/admin/deletePOI/${poiObj.id}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => response.json())
            .then(() => {this.setState({ showModalConfirmDeletePoi: false, notification: true, isEditPoi: false })})
            .then(setTimeout(() => {
                this.setState({ notification: false });
            }, 8000))
            .then(() => {this.setState({isUpdate: true})})
            // .then(() => {window.location.reload(true);})
            .then(() => {window.scroll(0, 0);})
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    // onClickConfirmEditPoi = () => {

    //     // AlertConfirm("แก้ไข POI","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
    //     //     if(isOk){
    //     //         const { poiObj, editPoiObj } = this.state;
    //     //         const {
    //     //             user_name,
    //     //             user_id,
    //     //             token
    //     //         } = this.props;
    //     //         console.log(poiObj)
    //     //         window.scrollTo(0, 0);
    //     //         // fetch(`http://api.fasttrack.co.th/updatePOI/${editPoiObj.id}`, {
    //     //             fetch(`http://203.150.199.244/api/admin/updatePOI/${editPoiObj.id}`, {
    //     //             method: 'post',
    //     //             headers: {
    //     //                 "Content-Type": "application/json; charset=utf-8",
    //     //                 "user_id": user_id,
    //     //                 "user_name": user_name,
    //     //                 "token": token
    //     //             },
    //     //             body: JSON.stringify({
    //     //                 "name" : poiObj.name || editPoiObj.name,
    //     //                 "group" : poiObj.group || editPoiObj.group,
    //     //                 "radius" : poiObj.radius || editPoiObj.radius,
    //     //                 "location" : {
    //     //                     "latitude" : poiObj.latitude || editPoiObj.lat,
    //     //                     "longitude" : poiObj.longitude || editPoiObj.lng
    //     //                 },
    //     //                 "icon" : {
    //     //                     "name" : poiObj.icon_name,
    //     //                     "color" : poiObj.icon_color,
    //     //                     "is_small" : false
    //     //                 },
    //     //                 "alert" : {
    //     //                     "email" : poiObj.email || editPoiObj.email,
    //     //                     "line_token" : poiObj.lineToken || editPoiObj.line_token,
    //     //                     "when" : {
    //     //                         "is_entry" : poiObj.isEntry,
    //     //                         "is_leave" : poiObj.isLeave
    //     //                     }
    //     //                 }
    //     //             })
    //     //         })
    //     //             .then(response => response.json())
    //     //             .then((data) => {

    //     //                 if(data.RESULT_STATUS == "000")
    //     //                     AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
    //     //                 else{
    //     //                     AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
    //     //                 }

    //     //                 this.setState({ 
    //     //                     showModalConfirmEditPoi: false, 
    //     //                     // notification: true, 
    //     //                     isEditPoi: false })
    //     //             })
    //     //             // .then(setTimeout(() => {
    //     //             //     this.setState({ notification: false });
    //     //             // }, 8000))
    //     //             .then(() => {this.setState({isUpdate: true})})
    //     //             // .then(() => {window.location.reload(true);})
    //     //             .then(() => {window.scroll(0, 0);})
    //     //             .catch(function (err) {
    //     //                 console.log('err:', err);
    //     //                 // POST failed...
    //     //             });
    //     //         }
    //     //     });

    // }

    onClickCancelUserInformation = () => {
        this.setState({ showModalConfirmEditPoi: false });
    }

    onClickBack = (id) =>{
        console.log('id',id)
        

        if(this.state.onOpenNear){
            this.state.onOpenNear = false;
        }
        
        this.setState({onOpenNear:true,poiId:id,openEdit:false});
    }

    onOpenAdd = () => {
        // this.setState({dataNewDriver: data}, () => this.onClickConfirmUserInformation());
        this.setState({
            openList : true,
            openAdd : true,
            onOpenNear : false,
            openEdit : false,
        });
    } 

    onOpenEdit = () => {

        this.setState({
            openEdit : true,
            onOpenNear: false,
            openAdd : false,
        });
        this.getPoiInfo();
    }

    onOpenNearList = (poi) => {

        if(this.state.onOpenNear){
            this.state.onOpenNear = false;
        }
        
        this.setState({onOpenNear:true,poiId:poi.id,openEdit:false,openAdd : false,});
    }

    getPoiInfo = () =>{

        const { poiId } = this.state;
        const { user_id, user_name,token} = this.props;
        // 18649
        fetch(`http://203.150.199.244/api/admin/getPOIInfo/${poiId}`, {
        // fetch(`http://203.150.199.244/api/admin/getDeviceInfo/18647`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
                
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {

                // let deviceInfo = {};
                // let specialSetting = [];
                // let inputOutputs = [];
                // let ad =[];
                // let alert = [];
                console.log('data',data.RESULT_DATA)
                // data.RESULT_DATA.map((poi,key) => {

                    this.setState({
                        
                        dataPOI:data.RESULT_DATA[0],
                        
                    });

                // });

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }
    
    handleClickUpdatePOI(isUpdatePOI){
        console.log(isUpdatePOI)
        if(this.props.onClickUpdatePOI && this.props.onClickUpdatePOI!=null)
            this.props.onClickUpdatePOI(isUpdatePOI);
    }
    handleSetVisiblePOILayer(isVisible){
        if(this.props.onSetVisiblePOILayer && this.props.onSetVisiblePOILayer!=null)
            this.props.onSetVisiblePOILayer(isVisible);
    }
    handleSetVisiblePOIName(isVisible){
        if(this.props.onSetVisiblePOIName && this.props.onSetVisiblePOIName!=null)
            this.props.onSetVisiblePOIName(isVisible);
    }
    handleRefreshPOI(){
        if(this.props.onRefreshPOI && this.props.onRefreshPOI!=null)
            this.props.onRefreshPOI();
    }
    handleZoomToLatLong(lat,long){
        if(this.props.onZoomToLatLong && this.props.onZoomToLatLong!=null)
            this.props.onZoomToLatLong(lat,long);
    }

    componentDidUpdate(){
        console.log('componentDidUpdate','POIconfig')
        console.log(this.props.lonlatByMark)
    }

    render() {
        const { editPoiObj, isEditPoi,
             showModalConfirmEditPoi, notification, isUpdate, showModalConfirmDeletePoi,
             openList,
             openAdd ,
             openEdit,
             onOpenNear,
            dataPOI } = this.state;
        if (isUpdate) {
            this.setState({isUpdate: false});
            return (<ListPoi onClickRowListTable={this.onClickRowListTable}
                onClickDeletePoi={this.onClickDeletePoi}
                onClickCancelEditPoi={this.onClickCancelEditPoi}
                onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                token={this.props.token}
                onBack={this.onClickBack}
                openNearList={this.onOpenNearList} 
                onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                onSetVisiblePOILayer = {this.handleSetVisiblePOILayer.bind(this)}
                onSetVisiblePOIName = {this.handleSetVisiblePOIName.bind(this)}
                onRefreshPOI={this.handleRefreshPOI.bind(this)}
                />)
        }
        console.log("getAddressLocation tide",this.props.token,this.props.lonlatByMark,this.props.selectPOIByMap)
        return (
                <div  style={{height: "calc(100vh - (122px))", overflowY:"auto"}}>

                            {
                                openList &&
                                // <div style={{height:"40vh"}}>
                               

                               
                                <ListPoi
                                    onClickRowListTable={this.onClickRowListTable}
                                    onClickDeletePoi={this.onClickDeletePoi}
                                    onClickCancelEditPoi={this.onClickCancelEditPoi}
                                    onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                                    token={this.props.token}
                                    onBack={this.onClickBack}
                                    openNearList={this.onOpenNearList}
                                    openAdd={this.onOpenAdd}
                                    onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                                    onSetVisiblePOILayer = {this.handleSetVisiblePOILayer.bind(this)}
                                    onSetVisiblePOIName = {this.handleSetVisiblePOIName.bind(this)}
                                    onZoomToLatLong = {this.handleZoomToLatLong.bind(this)}
                                    poiId = {this.props.selectPOIByMap}
                                    onRefreshPOI={this.handleRefreshPOI.bind(this)}
                                />

                                
                                // </div>
                            }
                            {/* <br/> */}
                            {
                                onOpenNear &&
                                // <div style={{height:"40vh"}}>
                                    <NearTrackingList poiId={this.state.poiId} openEdit={this.onOpenEdit} 
                                    onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                                    token={this.props.token}
                                    />
                                // </div>
                                
                            }
                            {
                                openEdit &&
                                <EditPoi
                                    // editPoiObj={editPoiObj}
                                    onClickCancelEditPoi={this.onClickCancelEditPoi}
                                    onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                                    onClickDeletePoi={this.onClickDeletePoi}
                                    onBack={this.onClickBack}
                                    token={this.props.token}
                                    dataPOI={dataPOI}
                                    onRefreshPOI={this.handleRefreshPOI.bind(this)}
                                    onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                                    lonlat={this.props.lonlatByMark}
                                />
                            }
                             {
                                openAdd &&
                                <EditPoi
                                    // editPoiObj={editPoiObj}
                                    onClickCancelEditPoi={this.onClickCancelEditPoi}
                                    onClickConfirmEditPoi={this.onClickConfirmUserInformation}
                                    onClickDeletePoi={this.onClickDeletePoi}
                                    onBack={this.onClickBack}
                                    token={this.props.token}
                                    dataPOI={dataPOI}
                                    onClickConfirmAddPoi={this.onClickConfirmAddPoi}
                                    ckAdd={true}
                                    onRefreshPOI={this.handleRefreshPOI.bind(this)}
                                    onClickUpdatePOI = {this.handleClickUpdatePOI.bind(this)}
                                    lonlat={this.props.lonlatByMark}
                                />
                            }

                            
                             {/* { showModalConfirmEditPoi &&
                                    <ModalConfirmEditPoi
                                        onClickCancelUserInformation={this.onClickCancelUserInformation}
                                        onClickConfirmUserInformation={this.onClickConfirmEditPoi}
                                    />
                                }
                                { showModalConfirmDeletePoi  &&
                                    <ModalConfirmDelete
                                        onClickCancelDelete={this.onClickCancelDelete}
                                        onClickConfirmDelete={this.onClickConfirmDelete}
                                    />
                                } */}
                    </div>

            );
        }
    }

POIconfig.propTypes = {
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired
}


export default POIconfig;



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/POI/POIconfig.js